import { useQuery } from '@tanstack/react-query';
import { checkStats, getReportingUrls } from 'api/stats';

import { matchPath, useLocation } from 'react-router-dom';
import { RouteList } from 'types';
import { queryKeys } from 'utils';
import { useCampaignId } from './useCampaignId';

export const useStats = () => {
  const campaignId = useCampaignId();

  const { pathname } = useLocation();

  const isOverviewPage = !!matchPath({ path: RouteList.CampaignOverview }, pathname);

  const checkStatsQuery = useQuery({
    queryKey: queryKeys.campaignStats.byCampaignId(campaignId!),
    queryFn: () => checkStats(campaignId!),
    enabled: isOverviewPage && !!campaignId,
  });

  return { checkStatsQuery };
};

export const useReportingUrls = () => {
  const campaignId = useCampaignId();

  const { pathname } = useLocation();

  const isOverviewPage = !!matchPath({ path: RouteList.CampaignOverview }, pathname);

  const getReportingUrlsQuery = useQuery({
    queryKey: queryKeys.campaignReportingUrls.byCampaignId(campaignId!),
    queryFn: () => getReportingUrls(campaignId!),
    enabled: isOverviewPage && !!campaignId,
  });

  return { getReportingUrlsQuery };
};
